import React, { useState, useEffect } from "react";
import styles from "./JokerAiPocket.module.css";
import AssetsPack from "../../../../../util/AssetsPack";
import PocketCard, { PocketCardStates } from "./components/PocketCard";
import clsx from "clsx";
import OnboardingCard from "./components/OnboardingCard";
import { HitlMessage } from "../../../../../api/responsePayload/HitlMessageResponse";
import { useAppSelector } from "../../../../../store/common/hooks";

interface JokerAiPocketrops {
  endConversationCallback: () => void;
}

const JokerAiPocket: React.FC<JokerAiPocketrops> = ({
  endConversationCallback,
}) => {
  const [showCard, setShowCard] = useState(false);
  const [countdown, setCountdown] = useState<number>(0);
  const [updatingContext, setUpdatingContext] = useState(false);
  const reduxUpdatingContext = useAppSelector(
    (state) => state.chatbot.isUpdatingSmartContext
  );
  const [aiMessageList, setAiMessageList] = useState<HitlMessage[]>([]);

  const reduxAiMessageList = useAppSelector(
    (state) => state.chatbot.aiMessageList
  );

  useEffect(() => {
    setUpdatingContext(reduxUpdatingContext);
    if (reduxUpdatingContext) {
      setShowCard(() => {
        const hasSeen =
          sessionStorage.getItem("JokerAiPocketOnboardingSeen") === "true";
        if (!hasSeen) {
          sessionStorage.setItem("JokerAiPocketOnboardingSeen", "true");
          setCountdown(5);
        } else {
          setCountdown(0);
        }
        return true;
      });
    }
  }, [reduxUpdatingContext]);

  useEffect(() => {
    setAiMessageList(reduxAiMessageList);
  }, [reduxAiMessageList]);

  const handleTabClicked = () => {
    setShowCard((prev) => {
      const opening = !prev;
      if (opening) {
        const hasSeen =
          sessionStorage.getItem("JokerAiPocketOnboardingSeen") === "true";
        if (!hasSeen) {
          sessionStorage.setItem("JokerAiPocketOnboardingSeen", "true");
          setCountdown(5);
        } else {
          setCountdown(0);
        }
      } else {
        setCountdown(0);
      }
      return opening;
    });
  };

  const handleOnBoardingClosed = () => {
    setCountdown(0);
  };

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (countdown > 0) {
      timer = setTimeout(() => setCountdown(countdown - 1), 1000);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [countdown]);

  return (
    <div className={styles["container"]}>
      <div
        className={`${styles["pocket-card-container"]} ${
          showCard ? styles.slideIn : styles.slideOut
        }`}
      >
        {countdown > 0 || (aiMessageList.length <= 0 && !updatingContext) ? (
          <OnboardingCard timer={countdown} onClose={handleOnBoardingClosed} />
        ) : (
          <PocketCard
            state={
              updatingContext
                ? PocketCardStates.Loading
                : PocketCardStates.Content
            }
          />
        )}
      </div>
      <div className={clsx(styles["tab-view"])}>
        <div
          className={clsx(styles["end-conv-tab"], showCard && styles["active"])}
          onClick={endConversationCallback}
        >
          <div className={styles["joker-ai-text"]}>End Conversation</div>
        </div>
        <div
          className={clsx(styles["joker-ai-tab"], showCard && styles["active"])}
          onClick={handleTabClicked}
        >
          <img
            src={AssetsPack.icons.ICON_JOKER_AI.default}
            className={styles["joker-ai-image"]}
          />
          <div className={styles["joker-ai-text"]}>
            JokerAi<strong>Pocket</strong>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JokerAiPocket;
